import React, { Component } from 'react';
import {Row, Col, InputGroup, FormControl } from 'react-bootstrap';

import FormSort from './FormSort';

class FormSearch extends Component {
   constructor(props) {
      super(props);

      this.handleFilterTextInputChange = this.handleFilterTextInputChange.bind(this);
      this.handleFilterTagCLick = this.handleFilterTagCLick.bind(this);
      this.handleSortCLick = this.handleSortCLick.bind(this);
   }

   /*****************************************/
   /* HANDLE */
   /*****************************************/
   handleFilterTextInputChange(e) {this.props.onFilterTextInput(e.target.value);}
   handleFilterTagCLick(filterTag) {this.props.onFilterTag(filterTag)}
   handleSortCLick(sort) {this.props.onSort(sort)}

   /*****************************************/
   /* RENDER */
   /*****************************************/
   render() {
      return (
         <Row>
            <Col xs={12} sm={8} md={6}  lg={4}>
               <InputGroup>
                  <InputGroup.Addon><i className="fa fa-search fa-lg"></i></InputGroup.Addon>
                  <FormControl type="text" placeholder="Search" onChange={this.handleFilterTextInputChange} />
               </InputGroup>
               <div className="push-sm visible-xs-block"></div>
            </Col>
            <Col xs={12} sm={4}>
               <FormSort
                  sortInfo={this.props.sortInfo}
                  onSort={this.handleSortCLick} />
            </Col>
         </Row>
      )
   }
}

export default FormSearch;



// WEBPACK FOOTER //
// ./src/FormSearch.js